import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField, selectClasses, MenuItem } from '@mui/material';

// ----------------------------------------------------------------------

RHFSelect.propTypes = {
  children: PropTypes.node,
  name: PropTypes.string,
};

export default function RHFSelect({ name, children,selectMsg, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          select
          fullWidth
          SelectProps={{ native: true }}
          error={!!error}
          helperText={error?.message}
          {...other}
        >
         {/* {selectMsg ? <option disabled value={''}>{selectMsg}</option> : null} */}

         {selectMsg ? <MenuItem disabled value={''} >{selectMsg}</MenuItem> : null}
          {children}
        </TextField>
      )}
    />
  );
}
